// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeatureSlider_main {
  display: flex;
  justify-content: center;
}

.FeatureSlider {
  width: 90%;
  /* display: flex;
  justify-content: center; */
}




.FeatureCard {
    display: flex;
    justify-content: center;
    padding: 20px;
  }


  .FeatureSlider .slick-prev,
  .FeatureSlider .slick-next {
      background-color: transparent; /* Keeps the background transparent */
      border: none; /* Removes any border */
      position: absolute; /* Positions arrows absolutely within their parent container */
      
  }
  
 
  
  .FeatureSlider .slick-prev:before,
  .FeatureSlider .slick-next:before {
      color: #9E54E3;
      font-size: 20px;
  }
 
  
  
  .FeatureSlidercard {
    width: 100%;
    max-width: 360px; /* Optimal width for mobile devices */
    /* border: 1px solid #ccc; */
    border-radius: 8px;
    overflow: hidden;
    /* box-shadow: 0 2px 5px rgba(0,0,0,0.1); */
  }


  .FeatureSlidercard-img_main{
    background: linear-gradient(to bottom right, #691A6F, #7511D3);
    border-radius: 50%  ;
  }
  
  .FeatureSlidercard-img {
    width: 100%;
    height: 300px; /* Set a fixed height or use aspect ratio */
    object-fit: contain;
    
  }
  
  .FeatureSlidercard-body {
    padding: 25px;
    text-align: start;
    background-color: #fff;
    border: 1px solid #D8BCF6;
    border-radius: 18px;
    margin-bottom: 10px;


  }

  .FeatureSlidercard-body_h1{
    margin-top: 10px;
  }

  .FeatureSlidercard-title{
    margin-top: 10px;
  }

  .FeatureSlidercard-text{
    margin-top: 10px;
  }


  .FeatureSlidercard-title{
font-family: Sora;
font-size: 20px;
color: black;
font-weight: 600;
line-height: 28px;
letter-spacing: 0.15000000596046448px;
text-align: left;

  }
  
  .FeatureSlidercard-text{
color: #7A8089;
;
font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 26px;
text-align: left;

  }

  .FeatureSlidercard-body h3 img{
    padding: 10px;
    background-color: #F3EAFD;
    border-radius: 14px;
  }
  
  /* Responsive adjustments */
  
  `, "",{"version":3,"sources":["webpack://./src/FeatureSlider/FeatureSlider.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV;4BAC0B;AAC5B;;;;;AAKA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;EACf;;;EAGA;;MAEI,6BAA6B,EAAE,qCAAqC;MACpE,YAAY,EAAE,uBAAuB;MACrC,kBAAkB,EAAE,8DAA8D;;EAEtF;;;;EAIA;;MAEI,cAAc;MACd,eAAe;EACnB;;;;EAIA;IACE,WAAW;IACX,gBAAgB,EAAE,qCAAqC;IACvD,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;EAC7C;;;EAGA;IACE,8DAA8D;IAC9D,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa,EAAE,2CAA2C;IAC1D,mBAAmB;;EAErB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;;;EAGrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;AACF,iBAAiB;AACjB,eAAe;AACf,YAAY;AACZ,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;;EAEd;;EAEA;AACF,cAAc;;AAEd,kBAAkB;AAClB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;;EAEd;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,2BAA2B","sourcesContent":[".FeatureSlider_main {\n  display: flex;\n  justify-content: center;\n}\n\n.FeatureSlider {\n  width: 90%;\n  /* display: flex;\n  justify-content: center; */\n}\n\n\n\n\n.FeatureCard {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n  }\n\n\n  .FeatureSlider .slick-prev,\n  .FeatureSlider .slick-next {\n      background-color: transparent; /* Keeps the background transparent */\n      border: none; /* Removes any border */\n      position: absolute; /* Positions arrows absolutely within their parent container */\n      \n  }\n  \n \n  \n  .FeatureSlider .slick-prev:before,\n  .FeatureSlider .slick-next:before {\n      color: #9E54E3;\n      font-size: 20px;\n  }\n \n  \n  \n  .FeatureSlidercard {\n    width: 100%;\n    max-width: 360px; /* Optimal width for mobile devices */\n    /* border: 1px solid #ccc; */\n    border-radius: 8px;\n    overflow: hidden;\n    /* box-shadow: 0 2px 5px rgba(0,0,0,0.1); */\n  }\n\n\n  .FeatureSlidercard-img_main{\n    background: linear-gradient(to bottom right, #691A6F, #7511D3);\n    border-radius: 50%  ;\n  }\n  \n  .FeatureSlidercard-img {\n    width: 100%;\n    height: 300px; /* Set a fixed height or use aspect ratio */\n    object-fit: contain;\n    \n  }\n  \n  .FeatureSlidercard-body {\n    padding: 25px;\n    text-align: start;\n    background-color: #fff;\n    border: 1px solid #D8BCF6;\n    border-radius: 18px;\n    margin-bottom: 10px;\n\n\n  }\n\n  .FeatureSlidercard-body_h1{\n    margin-top: 10px;\n  }\n\n  .FeatureSlidercard-title{\n    margin-top: 10px;\n  }\n\n  .FeatureSlidercard-text{\n    margin-top: 10px;\n  }\n\n\n  .FeatureSlidercard-title{\nfont-family: Sora;\nfont-size: 20px;\ncolor: black;\nfont-weight: 600;\nline-height: 28px;\nletter-spacing: 0.15000000596046448px;\ntext-align: left;\n\n  }\n  \n  .FeatureSlidercard-text{\ncolor: #7A8089;\n;\nfont-family: Inter;\nfont-size: 16px;\nfont-weight: 400;\nline-height: 26px;\ntext-align: left;\n\n  }\n\n  .FeatureSlidercard-body h3 img{\n    padding: 10px;\n    background-color: #F3EAFD;\n    border-radius: 14px;\n  }\n  \n  /* Responsive adjustments */\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
